import { SubmitRequestComponent } from './submit-request.component';

export const components = {
  submitRequest: SubmitRequestComponent
};
